export default __webpack_public_path__ + "static/media/logo-us-gap.dda37f8c.svg";